export const isUsableRepurchaseVoucher = (voucher) =>
    Boolean(voucher?.code) && Number(voucher?.discount) > 0;
